import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { FotografiasService } from '../../../services/fotografias.service';

@Component({
	selector: 'kt-ver-foto',
	templateUrl: './ver-foto.component.html',
	styleUrls: ['./ver-foto.component.scss']
})
export class VerFotoComponent implements OnInit {
	@ViewChild('myImage', { static: true }) image: ElementRef

	public imei: string;
	public id: string;
	public fechaImagen;

	public loadingVisible: boolean = false;
	public hiddenImg: boolean = true;

	constructor(private dialogRef: MatDialogRef<VerFotoComponent>,
		@Inject(MAT_DIALOG_DATA) public data) { }

	ngOnInit() {
		this.fechaImagen = this.data.fechaHora;
		this.id = this.data.id
		this.image.nativeElement.src = this.data.imagen
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
